// The modal pane's loading placeholder — shown while a seeded modal hydrates its
// detail (the rail + header already render from the seed, so only the form is
// pending). Reserves the form's shape with the shared `.bl-block` pulse so the
// real fields drop in without a jump. Used by every master-detail modal pane.
const bar = (w: string, h: number, mt = 0) => (
  <div className="bl-block" style={{ width: w, height: h, marginTop: mt, borderRadius: 'var(--radius-sm)' }} />
);

export function PaneSkeleton() {
  return (
    <div className="pane anim-fade" aria-busy="true">
      <div className="pane-scroll">
        <div className="pane-head">
          <div className="bl-block" style={{ width: 42, height: 42, borderRadius: '50%' }} />
          <div style={{ flex: 1 }}>{bar('45%', 15)}{bar('65%', 10, 7)}</div>
        </div>
        <div className="scard">{bar('30%', 11)}{bar('100%', 44, 10)}</div>
        <div className="scard">{bar('30%', 11)}{bar('100%', 38, 10)}{bar('100%', 38, 8)}</div>
        <div className="scard">{bar('30%', 11)}{bar('100%', 52, 10)}</div>
      </div>
    </div>
  );
}
